import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IMinimizedItemResponseInstance,
} from '@toolify/server/src/controllers/MinimizedItemController/types/IMinimizedItemResponseInstance'

export function mapMinimizedItemResponseInstance(
  minimizedItem: IToJson<IMinimizedItemResponseInstance>,
): IMinimizedItemResponseInstance {
  return {
    ...minimizedItem,
    minimizedAt: new Date(minimizedItem.minimizedAt),
    lastSeenAt: new Date(minimizedItem.lastSeenAt),
  } as IMinimizedItemResponseInstance
}
